import React, { Fragment, useCallback, useState, useEffect } from "react";
import { format } from "date-fns";
import PageHead from "../../components/pageHead";
import Button from "../../components/button";
import useMediaQuery from "../../hooks/useMediaQuery";
import MobileNav from "../../components/mobileNav";
import styles from "./style.module.css";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import useLogout from "../../hooks/useLogout";

const Billing = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const axiosPrivate = useAxiosPrivate();
  const logout = useLogout();
  const [loading, setLoading] = useState(false);
  const [trialData, setTrialData] = useState({});

  const cancelSubscription = useCallback(
    async () => {
      setLoading(true);
      try {
        let url = `payment/cancel-trial-subscription`;
        let options = {
          method: "PUT",
          url,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.data.status === "canceled") {
              logout();
            }
          })
          .catch((err) => {
            console.error("Error canceling trial subscription:", err);
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        console.error("Error canceling trial subscription:", error);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const getInvoicePdf = useCallback(async () => {
    setLoading(true);
    try {
      let url = `payment/download-invoice`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          const pdfUrl = response.data.data.invoicePdfUrl;
          // Create a temporary anchor element
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.target = "_blank";

          // // Suggest a filename for the user. The browser may use it.
          // link.setAttribute("download", "invoice.pdf");

          // Append the link to the body, click it, and then remove it.
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRenewalDate = useCallback(async () => {
    setLoading(true);
    try {
      let url = `payment/trial-status`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          console.log(response.data.data);
          setTrialData(response.data.data);
          if (response.data.data.trialStatus === "expired") {
            logout();
          }
        })
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getRenewalDate();
  }, [getRenewalDate]);

  return (
    <Fragment>
      <PageHead title="Billing" logo={isMobile} />
      <div className={styles.body}>
        {loading && (
          <div className={styles.body_print_loader}>
            <div className={styles.body_print_loader_inner} />
          </div>
        )}
        <div className={styles.body_view}>
          <div className={styles.body_view_row}>
            <div className={styles.bill_details}>
              <div className={styles.bill_details_head}>
                <h2>Order History</h2>
                <p>Manage billing information and view receips</p>
              </div>
              {trialData.membership === "premium" &&
              !trialData.promoCodeUsed ? (
                <div className={styles.bill_history}>
                  <div className={styles.bill_history_item}>
                    <div className={styles.bill_history_item_head}>Date</div>
                    <div className={styles.bill_history_item_value}>
                      {trialData.lastPaymentDate &&
                        format(
                          new Date(trialData.lastPaymentDate),
                          "MMMM dd, yyyy"
                        )}
                    </div>
                  </div>
                  <div className={styles.bill_history_item}>
                    <div className={styles.bill_history_item_head}>Type</div>
                    <div className={styles.bill_history_item_value}>
                      {trialData.membership} Membership
                    </div>
                  </div>
                  <div className={styles.bill_history_item}>
                    <div className={styles.bill_history_item_head}>Receipt</div>
                    <div className={styles.bill_history_item_value}>
                      <span onClick={getInvoicePdf}>Download</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.bill_no_history}>No history found</div>
              )}
            </div>
            <div className={styles.body_view_col}>
              <div className={styles.bill_details_card}>
                <div className={styles.bdc_sup_title}>Your Plan</div>
                <div className={styles.bdc_title}>{trialData.membership}</div>
                {trialData.membership === "premium" && (
                  <div className={styles.bdc_amt}>
                    ${trialData.lastPaymentAmount}
                  </div>
                )}
                {trialData.membership === "free" ? (
                  <div className={styles.bdc_renewal}>
                    Payment on{" "}
                    {trialData.trialEndDate &&
                      format(new Date(trialData.trialEndDate), "MMMM dd, yyyy")}
                  </div>
                ) : trialData.promoCodeUsed ? (
                  <div className={styles.bdc_renewal}>
                    Used promo code to get 100% off
                  </div>
                ) : (
                  <div className={styles.bdc_renewal}>
                    Membership started on{" "}
                    {trialData.lastPaymentDate &&
                      format(
                        new Date(trialData.lastPaymentDate),
                        "MMMM dd, yyyy"
                      )}
                  </div>
                )}
                {trialData.membership === "free" && (
                  <div className={styles.bdc_btn}>
                    <Button
                      type="button"
                      buttonType="outlined"
                      onClick={cancelSubscription}
                      loading={loading}
                      title="Cancel Subscription"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isMobile && <MobileNav defaultActive={true} isScrolling={false} />}
    </Fragment>
  );
};

export default Billing;
